import api from './api';
import router from '../../router';

//Path Regex to check if socket listener should be used
const pathRegex = /^\/scores/;

const state = {
	error: null,
	scores: {},
};

const getters = {};

const mutations = {
	setError(state, { error }) {
		state.error = error;
	},

	setScores(state, scores) {
		const newScores = {};
		for (const score of scores) {
			newScores[score.user] = score;
		}
		state.scores = newScores;
	},
};

const actions = {
	async loadScores({ commit }) {
		const result = await api.getScores();
		commit('setScores', result.data);
	},

	socket_savedScore({ dispatch }, payload) {
		if (!pathRegex.test(router.currentRoute._value.path)) {
			return;
		}

		dispatch('loadScores');
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
